

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { konsole } from '@/services/Konsole';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faImages } from '@fortawesome/pro-solid-svg-icons';
import VueGallery from 'vue-gallery';

@Component({
  components: { VueGallery },
})
export default class Gallery extends Vue {
  @Prop({ required: true }) public largeImages!: string[];
  @Prop({ required: true}) public fullImages!: string[];
  public index = null;


  constructor() {
    super();
    library.add(faImages);
    // konsole.init('new instance of Gallery');
  }
}
